import _ from 'lodash-es';

const themeData = {
    "base": {
        token: {
            colorPrimary: '#16A560',
            colorLink: '#16A560',
            fontFamily: '\'Lato\', sans-serif'
        },
        components: {
            Button: {
                primaryShadow: '0',
                defaultBg: 'white',
                defaultBorder: '1px solid #b2b2b2',
                fontWeight: 'bold'
            },
            Modal: {
                titleFontSize: 18,
                titleLineHeight: 1.43,
                titleColor: '#393939',
            },
            Table: {
                cellPaddingBlock: 8,
                headerBg: 'white',
                headerSplitColor: 'white'
            },
            Checkbox: {
                color: '#16A560'
            }
        }
    }
}

export default class Themes {
    static get(code) {
        return themeData[code] ? themeData[code] : themeData["base"];
    }

    static getPrimaryColor() {
        var themeCode = _.get(window, "CONFIG.Account.theme.code", "base");
        return _.get(window, "CONFIG.Account.theme.main_color",
            _.get(themeData, themeCode + ".token.colorPrimary", "16A560"))
    }
}